import { Folder } from "lucide-react";
import { useFolders } from "@/hooks/folders";
import { cn } from "@/lib/utils";

interface FolderBadgeProps {
  folderId: string | null;
  className?: string;
  showIcon?: boolean;
  size?: "sm" | "md";
}

export const FolderBadge = ({ folderId, className, showIcon = true, size = "sm" }: FolderBadgeProps) => {
  const { folders } = useFolders();

  if (!folderId) return null;

  const folder = folders.find((f) => f.id === folderId);
  if (!folder) return null;

  const sizeClasses = {
    sm: "text-xs px-2 py-1",
    md: "text-sm px-2.5 py-1.5",
  };

  const iconSizes = {
    sm: "h-3 w-3",
    md: "h-3.5 w-3.5",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full font-medium gap-1 transition-colors min-w-0 max-w-full shrink",
        sizeClasses[size],
        className
      )}
      style={{
        backgroundColor: `${folder.color}15`,
        color: folder.color,
        border: `1px solid ${folder.color}30`,
      }}
    >
      {showIcon && <Folder className={iconSizes[size]} style={{ color: folder.color }} />}
      <span className="truncate min-w-0">{folder.name}</span>
    </span>
  );
};
